export default "__VITE_ASSET__CMnvELz6__"